module.exports = __webpack_public_path__ + "img/instagram-grey.342c22ea.svg";